<template>
  <tela-component title="Relatório Pedidos Realizados">
    <v-progress-linear
      indeterminate
      size="35"
      v-if="loading"
    ></v-progress-linear>
    <v-card flat rounded="lg" v-else>
      <v-card-text>
        <v-form>
          <selecionar-vendedor-relat />
          <v-text-field
            type="date"
            label="Data inicial"
            v-model="filtro.dtini"
          ></v-text-field>
          <v-text-field
            type="date"
            label="Data final"
            v-model="filtro.dtfim"
          ></v-text-field>
          <!--<v-select
            :items="tiposPedido"
            append-icon=""
            label="Tipo Pedido"
            no-data-text="Nenhum tipo encontrado"
            item-text="descricao"
            v-model="filtro.tipoped"
            item-value="codigo"
          ></v-select>-->
          <v-select
            label="Status Pedido"
            no-data-text="Nenhum status encontrado"
            v-model="filtro.status"
            :items="getAllStatus()"
            item-text="descricao"
            item-value="codigo"
          ></v-select>
          <v-btn block color="info" rounded depressed @click="gerarRelatorio()"
            >Gerar relatório</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import moment from "moment";
import { mapActions, mapState } from "vuex";
import SelecionarVendedorRelat from './SelecionarVendedorRelat.vue';
//import { getUrlRelatorio } from "@/global";
//import axios from "axios";
export default {
  components: {
    TelaComponent,
    SelecionarVendedorRelat,
  },
  computed: {
    ...mapState("relatorios",["vendedorSelecionado"]),
    ...mapState("pedidos", ["config", "status"]),
    ...mapState("usuario", ["usuarioLogado"]),
  },
  data: () => ({
    filtro: {
      dtini: moment().subtract(30, "d").format("YYYY-MM-DD"),
      dtfim: moment().format("YYYY-MM-DD"),
      tipoped: 0,
      status: 0,
    },
    loading: true,
    tiposPedido: [],
  }),
  methods: {
    ...mapActions("pedidos", ["getConfigPedidos", "getStatusPedido"]),
    getAllStatus() {
      return this.status;
    },
    gerarRelatorio() {
      window.open(
        `${
          process.env.VUE_APP_BASE_URL
        }/nutricao-animal/relatorios/pedidos?token=${
          this.usuarioLogado.token
        }&dtini=${moment(this.filtro.dtini).format(
          "DD-MM-YYYY"
        )}&dtfim=${moment(this.filtro.dtfim).format("DD-MM-YYYY")}&status=${
          this.filtro.status
        }&codvendedor=${this.vendedorSelecionado}`,
        "_blank"
      );
    },
  },
  async mounted() {
    this.loading = true;
    //await this.getConfigPedidos();
    await this.getStatusPedido();

    /*this.tiposPedido = [];
    this.tiposPedido.push({ descricao: "TODOS", codigo: 0 });
    this.config.tipospedido.forEach((cfg) => {
      this.tiposPedido.push(cfg);
    });*/
    this.loading = false;
  },
};
</script>

<style>
</style>